<template>
  <div class="freight-templete-detail">
    <el-form label-width="140px">
      <el-form-item label="模版名称">
        <el-input v-model="form.templateName"></el-input>
      </el-form-item>
      <el-form-item label="计费方式">
        <el-radio v-model="form.billingMethod" :label="1">按重量/吨</el-radio>
        <!-- <el-radio v-model="form.billingMethod" :label="2" disabled>按件数</el-radio> -->
      </el-form-item>
      <el-form-item label="未配置区域规则">
        <el-radio v-model="form.rulesConfigureType" :label="1">未配置区域运费提示买家议价</el-radio>
        <!-- <el-radio
          v-model="form.rulesConfigureType"
          :label="2"
          disabled
        >未配置区域买家不可选择商家配送</el-radio> -->
      </el-form-item>
      <el-form-item label="配送区域">
        <el-table :data="form.rules" header-cell-class-name="table-header-cell">
          <el-table-column label="区域" min-width="4">
            <template slot-scope="scope">
              <span>{{ scope.row.ruleName }}</span>
              <el-button class="m-l5" type="text" @click="openDialog(scope.$index)">{{
                scope.row.ruleName ? '重新选择' : '选择'
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="运费（元/吨）" min-width="1">
            <template slot-scope="scope">
              <el-input v-model="scope.row.fare" @input="inputPrice(scope.$index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="1">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteArea(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <div class="text-right">
          <el-button type="default" @click="addArea()">指定可配送区域和运费</el-button>
        </div>
        <div class="m-t70">
          <el-button class="btn" type="primary" @click="save">保存</el-button>
          <el-button class="btn" type="default" @click="back">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialog.isShow" title="修改区域" center>
      <!-- 渲染时要在4级中过滤、禁用指定数据，手动重置成本太高，因此直接 v-if -->
      <area-tree
        v-if="dialog.isShow"
        :checked-address-list="dialog.checkedAddressList"
        :disabled-codes-obj="dialog.disabledCodesObj"
        ref="area-tree"
      ></area-tree>
      <div class="text-right m-t20">
        <el-button type="primary" @click="dialogSaveArea">确定</el-button>
        <el-button type="default" @click="closeDialog">取消</el-button>
      </div>
      <!-- <el-button type="primary" @click="setDefault">设置默认值</el-button> -->
    </el-dialog>
  </div>
</template>

<script>
import areaTree from './component/areaTree'
export default {
  name: 'FreightTempleteDetail',
  components: {
    areaTree
  },
  data() {
    return {
      form: {
        templateName: '',
        billingMethod: 1,
        rulesConfigureType: 1,
        rules: []
      },
      tree: {
        props: {
          label: 'name',
          isLeaf: 'leaf'
        },
        // load: async (node, resolve) => {
        //   const { level, data } = node
        //   console.log(node)
        //   if (level === 0) {
        //     resolve(await this.getProvinces())
        //   } else if (level === 1) {
        //     return resolve(await this.getCities(data.code))
        //   } else if (level === 2) {
        //     return resolve(await this.getAreas(data.code))
        //   } else if (level === 3) {
        //     return resolve(await this.getRegions(data.code))
        //   }
        //   resolve([])
        // },
        data: [],
        areaTreeInstance: null // 地区树控件实例
      },
      dialog: {
        isShow: false,
        ruleIndex: -1,
        checkedAddressList: [],
        // 新增、编辑时过滤其他规则已配置区域，key 为 addressType，value 为 code 集合
        disabledCodesObj: {}
      }
    }
  },
  computed: {
    // getDeliveryAreaList() {
    //   const levelDic = {
    //     1: 'provinceName'
    //   }
    //   return this.form.rules.map(d => )
    // }
  },
  async created() {
    const { id } = this.$route.query
    if (id) this.getDetail(id)
    this.$listeners && this.$listeners.scrollToTop && this.$listeners.scrollToTop()
  },
  methods: {
    async getDetail(id) {
      const res = await this.$get('lgcenter.getLgFreightTemplateDetailsById', {
        lgFreightTemplateId: id
      })
      const { success, data } = res
      if (success) {
        if (data && data[0]) {
          const rules = data[0].rules.map(r => {
            return {
              ...r,
              fare: r.fare / 100 // 运费换算
            }
          })
          this.form = {
            ...data[0],
            rules
          }
          // const { templateName, billingMethod, rulesConfigureType } = data[0]
          // this.form = {
          //   templateName,
          //   billingMethod,
          //   rulesConfigureType,
          //   rules: data[0].rules.map(({ ruleName, fare, addressList }) => {
          //     return { ruleName, fare, addressList }
          //   })
          // }
        }
      }
    },
    async openDialog(index) {
      this.dialog = {
        isShow: true,
        ruleIndex: index,
        checkedAddressList: this.form.rules[index].addressList,
        disabledCodesObj: this.getDisabledCodesObj(index)
      }
    },
    dialogSaveArea() {
      const { ruleIndex } = this.dialog
      const addressList = this.$refs['area-tree'].getCheckedHalfCheckedData()
      const ruleName = this.getRuleNameFromAddressList(addressList)
      this.form.rules[ruleIndex].ruleName = ruleName
      this.form.rules[ruleIndex].addressList = addressList
      this.closeDialog()
    },
    getRuleNameFromAddressList(addressList) {
      const names = addressList
        .filter(({ hasNextIndex }) => !hasNextIndex) // 过滤出被勾选的最后一级
        .sort((addr1, addr2) => {
          // 街道9位，省市区6位 故乘1000 相关联的省市区就会相近排列
          const code1 = addr1.code.length === 6 ? addr1.code * 1000 : addr1.code * 1
          const code2 = addr2.code.length === 6 ? addr2.code * 1000 : addr2.code * 1
          return code1 - code2
        })
        .map(({ name }) => name)
      return names.join('、')
    },
    addArea() {
      this.form.rules.push({
        ruleName: '',
        fare: 0,
        addressList: []
      })
    },
    deleteArea(index) {
      this.form.rules.splice(index, 1)
    },
    back() {
      this.$router.back()
      // this.$router.push({
      //   name: 'freightTempleteList'
      // })
    },
    closeDialog() {
      this.dialog.isShow = false
    },
    check() {
      let msg
      const { templateName, rules } = this.form
      if (!msg && !templateName) {
        msg = '请输入模版名称'
      }
      if (!msg && rules.length === 0) {
        msg = '请至少指定一条配送区域'
      }
      if (!msg) {
        const index = rules.findIndex(r => !r.ruleName)
        if (index > -1) {
          msg = `【配送区域】请选择第${index + 1}条的区域`
        }
      }
      if (msg) {
        this.$message.warning(msg)
        return false
      }
      return true
    },
    async save() {
      if (this.check()) {
        const api = this.form.id
          ? 'lgcenter.editLgFreightTemplate'
          : 'lgcenter.addLgFreightTemplate'
        const rules = this.form.rules.map(r => {
          return {
            ...r,
            fare: r.fare * 100 // 运费换算
          }
        })
        const { success, data } = await this.$post(api, {
          dto: {
            ...this.form,
            rules
          }
        })
        if (success && data[0] && data[0].value) {
          this.$message.success('操作成功')
          this.back()
        }
      }
    },
    inputPrice(index) {
      this.form.rules[index].fare = this.only2Decimal(this.form.rules[index].fare.toString())
    },
    // 控制小数点后2位
    only2Decimal(str) {
      try {
        str = str
          .replace(/[^\d.]/g, '')
          .replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        return str
      } catch (e) {
        return '0'
      }
    },
    // 获得除了当前 index 所有最后一级地址 code
    getDisabledCodesObj(currentIndex) {
      let disabledCodesObj = {
        1: [],
        2: [],
        3: [],
        4: []
      }
      this.form.rules
        .filter((rule, i) => i !== currentIndex) // 过滤当前规则数据
        .forEach(rule => {
          rule.addressList
            .filter(addr => !addr.hasNextIndex) // 过滤非最后一级地址数据
            .forEach(addr => {
              disabledCodesObj[addr.addressType].push(addr.code)
            })
        })
      return disabledCodesObj
    }
  }
}
</script>
<style lang="less">
.freight-templete-detail {
  .table-header-cell {
    background: #f5f7fa;
  }
}
</style>
<style lang="less" scoped>
.btn {
  width: 100px;
}
</style>
